import React from "react";
import { Fade, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    color: theme.palette.error.main,
    width: "100%",
  },
}));

const ErrorMessage = ({ children, align = "center", variant = "body1" }) => {
  const classes = useStyles();

  return (
    <Fade in>
      <Typography
        component="div"
        variant={variant}
        className={classes.container}
        align={align}
      >
        {children}
      </Typography>
    </Fade>
  );
};

export default ErrorMessage;
